import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { phoneNumberValidator } from 'src/app/shared/validators/phone-number.validator';

@Component({
  selector: 'app-super-agent-details-modal',
  standalone: false,
  templateUrl: './super-agent-details-modal.component.html',
  styleUrl: './super-agent-details-modal.component.scss'
})
export class SuperAgentDetailsModalComponent {
  form: FormGroup;
  isDarkMode!: boolean;

  details: any;


  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  ticketList: any[] = [];
  vehicleTypes: any[] = [];

  rememberMe: boolean;


  isInEditingMode: boolean = false;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SuperAgentDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();

    this.getAllVehicleTypes();

    this.form.get('vehicleTypeId')?.valueChanges.subscribe((id) => {
      const vehicle = this.vehicleTypes.find((v) => v.id === id);
      this.form.patchValue({ vehicleTypeName: vehicle ? vehicle.name : '' });
    });

    this.rememberMe = false;



    this.isInEditingMode = Boolean(this.dialogData?.isInEditingMode);

    if (!this.isInEditingMode) {
      this.form.disable()
    }



    if (this.dialogData?.id) {
      this.fetchDetails()
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      phoneNumber: ['', [Validators.required, phoneNumberValidator]],
      address: ['', [Validators.required]],
    });




  }

  allowEditing() {
    this.isInEditingMode = true;
    this.form.enable()
  }

  fetchDetails() {
    this.details = this.dialogData
    this.mapFormValues(this.dialogData)

    this.apiService
      .get(`/auth/user/super-agent/${this.dialogData?.id}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
       if(response.success) {
        this.details = response?.data
        this.mapFormValues(response?.data)
       }
      });
  }

  mapFormValues(data: any) {
    this.form.patchValue({
      phoneNumber: data?.phoneNumber,
      address: data?.address
    })
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to update this user?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.updateUser();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  addToTicketList(): void {
    if (this.form.valid) {
      this.ticketList.push(this.form.value);
      this.form.reset();
      this.showErrorMessages = false

    } else {
      this.showErrorMessages = true
    }
  }

  removeTicket(index: number): void {
    this.ticketList.splice(index, 1);
  }

  updateUser(): void {
    this.isSubmitting = true;
    this.form.disable();

    const formValues = this.form?.value;

    const request = {
      agentId: this.dialogData?.id,
      phoneNumber: formValues.phoneNumber,
      address: formValues.address,
      // parkId
    };

    this.apiService
      .post(`/auth/super-agent/update`, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.form.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
